<template>

  <div>

    <div class="ui large breadcrumb">
      <div class="section">
        <strong>Consulta de Produtos</strong>
      </div>
    </div>

    <div class="ui divider"></div>

    <products-filter ref="filter" :active="filterActive" :searching="loading" 
      @onSearch="onSearch" @onSelectCustomer="onSelectCustomer"/>

    <div v-if="loading" class="m-t-20"><i class="spinner circle loading blue icon"></i> Carregando ...</div>

    <div v-else class="ui small label m-t-15">
      <i class="info circle icon"></i>{{ infoLabel }}
    </div>

    <div v-if="$store.state.balances && $store.state.balances.length > 0" class="animated fadeIn" style="margin-top: 15px;">

      <div class="ui segment" style="padding: 20px !important;">
        <table class="ui very basic celled selectable tablet stackable table">
          <thead class="desktop-only">
            <tr>
              <th>Unidade</th>
              <th>Código</th>
              <th>Descrição</th>
              <th>Quantidade</th>
              <th>Acondicionamento</th>
              <th>Total</th>
              <th></th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="balance in $store.state.balances">
              <td><strong class="mobile-only">Unidade: </strong>{{ balance.branch.name }}</td>
              <td><strong class="mobile-only">Código: </strong>{{ balance.product.code }}</td>
              <td><strong class="mobile-only">Descrição: </strong>{{ balance.product.description }}</td>
              <td><strong class="mobile-only">Quantidade: </strong>{{ $formatInteger(balance.quantity) }}</td>
              <td><strong class="mobile-only">Acondicionamento: </strong>{{ balance.address }}</td>
              <td><strong class="mobile-only">Total: </strong>{{ $formatInteger(balance.total) }}</td>
              <td v-if="balance.sent">
                <div class="ui label">
                  <i class="check circle green icon"></i> {{ $store.state.user.isProspect ? 'Enviado' : 'Reservado' }}
                </div>
              </td>
              <td v-else>                
                <button v-if="$store.state.user.isProspect" class="ui mini basic left icon button" @click="showReserveDialog(balance)">
                  <i class="thumbs up blue icon"></i>
                  Tenho interesse
                </button>
                <button v-else class="ui mini basic left icon button" @click="showReserveDialog(balance)">
                  <i class="lock blue icon"></i>
                  Reservar
                </button>
              </td>
            </tr>                       
          </tbody>
        </table>
      </div>

    </div>

    <reserve-dialog ref="reserveDialog" :balance="selectedBalance" 
      :customer="selectedCustomer" :lChgCus="false" @onConfirm="onConfirm" />

  </div>

</template>

<script>

  import ProductsFilter from "./filter.vue"
  import ReserveDialog from "./reserve.vue"  
  import OppBalanceService from "@/services/opp-balance-service"

  export default {   
    
    data() {
      return {
        loading: false,
        filterActive: true,
        selectedBalance: null,
        selectedCustomer: null,
      }
    },

    computed: {

      infoLabel() {

        let label = ""

        if (!this.$store.state.balances) {
          
          label = "Selecione o produto, a bitola e a cor e clique em Pesquisar"

        } else if (this.$store.state.balances.length == 0) {

          label = "Nenhum registro encontrado"
        
        } else if (this.$store.state.balances.length == 1) {

          label = "1 registro encontrado"

        } else {

          label = this.$store.state.balances.length + " registros encontrados"
        }

        return label
      },
    },
    
    components: {
      ProductsFilter,
      ReserveDialog,
    },

    created() {

      if (this.$store.state.balances && this.$store.state.balances.length > 0)
        this.filterActive = false
    },

    methods: {

      onSelectCustomer(customer) {
        this.selectedCustomer = customer        
      },

      async onSearch(filter) {

        if (this.loading)
          return
        
        this.loading = true

        try {

          const balances = await OppBalanceService.searchBalances(filter)

          this.$store.commit("setBalances", balances)

          this.loading = false

          if (balances.length > 0) {
            this.$refs.filter.toggleActive()
            this.$scroll.toTop()
          }  
          
        } catch (error) {
          
          this.loading = false

          this.$errorHandler(error)
        }
      },

      showReserveDialog(balance) {

        this.selectedBalance = balance
        this.$refs.reserveDialog.show()    
      },

      onConfirm(data) {

        let balances = []

        this.$store.state.balances.forEach((bl) => {

          let balance = this.$cloneObject(bl)

          if (balance.branch.id == data.branch && 
              balance.product.code == data.productCode && 
              balance.idAddress == data.idAddress) {
            
            balance.sent = true    

            if (!this.$store.state.user.isProspect) {
              balance.quantity -= data.quantity
              balance.total -= data.total
            }
          }          

          balances.push(balance)
        })

        this.$store.commit("setBalances", balances)
      },
    },
  }

</script>

